import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ClientInviteUserModal.css';
import { CLIENT_ROLES } from 'services/utils/users-util';
import InviteUserModal, {
  UserModalState,
} from 'components/shared/modal/InviteUserModal';
import { ROLES } from 'services/utils/users-util';
import { formatPhoneNumber } from 'services/utils/text-util';
import {
  getBuildings,
  getCurrentClient,
  getForm,
  getInvalidFields,
  getRoles,
  getShowInviteClientUserModal,
  getValidationMessage,
} from 'selectors/admin/clients/clients';
import {
  loadRolesRequest,
  setShowInviteUserClientModal,
  submitInviteUserFormRequest,
  updateFormValue,
} from 'actions/admin/clients/clients';
import { Building } from 'domain/building';
import MultipleSelectList from 'components/shared/select/MultipleSelectList';

class ClientInviteUserModal extends Component {
  componentDidMount() {
    if (this.props.roles.length === 0) {
      this.props.dispatch(loadRolesRequest());
    }
  }

  handleClose = () => {
    this.props.dispatch(setShowInviteUserClientModal(false));
  };

  handleSubmit = () => {
    this.props.dispatch(
      submitInviteUserFormRequest(
        this.props.form,
        this.props.currentClient.id,
        this.props.roles
      )
    );
  };

  handleAttributeChange = (attribute, value) => {
    this.props.dispatch(updateFormValue(attribute, value));
  };

  handleBuildingSelect = (buildingId) => {
    if (
      this.props.form.buildingsId.find((id) => id === buildingId) !== undefined
    ) {
      this.props.dispatch(
        updateFormValue(
          'buildingsId',
          this.props.form.buildingsId.filter((id) => id !== buildingId)
        )
      );
    } else {
      this.props.dispatch(
        updateFormValue(
          'buildingsId',
          this.props.form.buildingsId.concat([buildingId])
        )
      );
    }
  };

  render() {
    let showBuildings = false;
    const businessMaganerRole = this.props.roles.find(
      (role) => role.name === ROLES.CLIENT_BUILDING_MANAGER
    );
    if (businessMaganerRole !== null) {
      showBuildings =
        this.props.form.rolesId.find((id) => id === businessMaganerRole.id) !==
        undefined;
    }

    return (
      <div>
        <InviteUserModal
          className="client-invite-user-modal"
          form={[
            {
              attribute: 'firstName',
              label: 'First Name',
              renderer: 'input',
            },
            {
              attribute: 'lastName',
              label: 'Last Name',
              renderer: 'input',
            },
            {
              attribute: 'title',
              label: 'Title',
              renderer: 'input',
            },
            {
              attribute: 'email',
              label: 'Email',
              renderer: 'input',
            },
            {
              attribute: 'phoneNumber',
              formatter: formatPhoneNumber,
              label: 'Phone Number',
              renderer: 'input',
            },
            {
              attribute: 'rolesId',
              label: 'Work Order Permissions',
              renderer: 'multiple',
              options: this.props.roles
                .filter((role) => role.name !== ROLES.OWNER)
                .map((role) => {
                  return { value: role.id, label: CLIENT_ROLES[role.name] };
                }),
            },
            {
              attribute: 'buildingsId',
              label: 'Building',
              renderer: (
                <div className="col-sm-12 building-container">
                  <div className="body-bold">
                    Please assign buildings to this user
                  </div>
                  <MultipleSelectList
                    options={this.props.buildings.map((building) => {
                      return {
                        id: building.id,
                        selected:
                          this.props.form['buildingsId'].find(
                            (id) => id === building.id
                          ) !== undefined,
                        value: Building.getPrettyName(building, true),
                      };
                    })}
                    show={5}
                    onSelect={this.handleBuildingSelect}
                  />
                </div>
              ),
              show: showBuildings,
            },
          ]}
          invalidFields={this.props.invalidFields}
          modalState={UserModalState.NEW}
          show={this.props.showInviteClientUserModal}
          values={this.props.form}
          validationMessage={this.props.validationMessage}
          onAttributeChange={this.handleAttributeChange}
          onClose={this.handleClose}
          onSubmit={this.handleSubmit}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    buildings: getBuildings(state),
    currentClient: getCurrentClient(state),
    form: getForm(state),
    invalidFields: getInvalidFields(state),
    roles: getRoles(state),
    showInviteClientUserModal: getShowInviteClientUserModal(state),
    validationMessage: getValidationMessage(state),
  };
})(ClientInviteUserModal);



// WEBPACK FOOTER //
// ./src/components/admin/clients/ClientInviteUserModal.js